import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { HeaderStyles } from './index.styles';

const HeaderSection = ({ image, title, caption, copy }) => (
  <HeaderStyles className="header-section header-section-mask header-section-light">
    <div className="header-section__media">
      <div className="container-md h-100 position-relative">
        <div
          className="header-section__image"
          style={{ backgroundImage: `url(${image})` }}
        />
      </div>
    </div>
    <div className="container-md position-relative mb-md-5">
      <div className="row header-section__title">
        <div className="offset-xl-1 col-md-7 col-sm-7 col-8">
          <h1 className="fs-h1 mb-4 font-weight-bold">{title}</h1>
        </div>
      </div>
      <div className="row header-section__caption">
        <div
          className={classNames('offset-xl-1 col-md-5 col-8', {
            caption,
            'pb-md-0 pb-5': !caption,
          })}
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      </div>
      <div className="row header-section__copy d-md-block d-none">
        <div
          className="offset-xl-1 col-lg-5 col-md-6 align-self-center"
          dangerouslySetInnerHTML={{ __html: copy }}
        />
      </div>
    </div>
  </HeaderStyles>
);
HeaderSection.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
  copy: PropTypes.string,
};

export default HeaderSection;
